import styles from './FilterRail.module.css'

interface GroupHeaderProps {
  label: string
  /** Muted helper shown only while the group is inactive. */
  hint?: string | null
  active: boolean
  onClear: () => void
}

/** Label / hint / "Clear" row shared by every filter group and score axis. */
const GroupHeader: React.VFC<GroupHeaderProps> = ({ label, hint, active, onClear }) => (
  <header className={styles.groupHead}>
    <span className={styles.groupLabel}>{label}</span>
    {!active && hint && <span className={styles.groupHint}>{hint}</span>}
    {active && (
      <button type="button" className={styles.groupClear} onClick={onClear}>
        {'Clear'}
      </button>
    )}
  </header>
)

export default GroupHeader
